module.exports = __webpack_public_path__ + "img/transparent.5c348d93.png";